const KEY = "coachly_utm";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v.slice(0, 100);
  });
  if (Object.keys(found).length) {
    localStorage.setItem(KEY, JSON.stringify({ ...found, landing: window.location.pathname }));
  }
  return getUtm();
}

export function getUtm() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}
